export const checkDinhDangSim = (phoneNumber) => {
  if (phoneNumber) {
    const suffix = [
      phoneNumber.slice(-8),
      phoneNumber.slice(-7),
      phoneNumber.slice(-5),
      phoneNumber.slice(-4),
      phoneNumber.slice(-6),
    ]; // Lấy 6 số đuôi của số điện thoại
    let arrAll = '';
    for (let x = 0; x < suffix.length; x++) {
      let indices = {};
      let arrayNumber = suffix[x].split('');
      for (let i = 0; i < arrayNumber.length; i++) {
        if (!indices[arrayNumber[i]]) {
          indices[arrayNumber[i]] = [];
        }
        indices[arrayNumber[i]].push(i);
      }
      let set = new Set([...suffix[x]]);
      let arr = [...set];
      const arrAZ = {};
      for (let i = 0; i < arr.length; i++) {
        if (i === 0) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'A';
          });
        }
        if (i === 1) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'B';
          });
        }
        if (i === 2) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'C';
          });
        }
        if (i === 3) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'D';
          });
        }
        if (i === 4) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'E';
          });
        }
        if (i === 5) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'F';
          });
        }
        if (i === 6) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'G';
          });
        }
        if (i === 7) {
          indices[arr[i]].map((row, j) => {
            arrAZ[row] = 'H';
          });
        }
      }
      if (arrAZ) {
        arrAll = Object.values(arrAZ).join('') + (arrAll ? ',' + arrAll : '');
      }
    }

    // console.log(arrAll)
    return arrAll;
  }
};
